import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Button from '@material-ui/core/Button';
import { KitFormAdd } from './KitForm';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Device from '../devices/Device';

const KitDetails = () => {
  const history = useHistory();
  const location = useLocation();
  const initialKit = (location.state && location.state.kit) || { no: '', description: '', Appareils: [] };
  const [editMode, setEditMode] = useState(false);
  const [createMode, setCreateMode] = useState(Boolean(location.state && location.state.createMode));
  const [kit, setKit] = useState(initialKit);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (location.state && location.state.createMode) {
      setCreateMode(true);
      setEditMode(true);
      setIsLoading(false);
      return;
    }

    if (location.state) {
      setEditMode(Boolean(location.state.editMode));
    }

    fetch(process.env.REACT_APP_PROXY_HOST + '/gere' + location.pathname, { method: 'GET' })
      .then((res) => res.json())
      .then((retkit) => setKit(retkit))
      .finally(() => setIsLoading(false));
  }, [location]);

  function getDeviceRole(val) {
    switch (parseInt(val, 10)) {
      case 1:
        return 'Telecommande';
      case 100:
        return 'Camera';
      default:
        return 'inconnu';
    }
  }

  const handleDelete = () => {
    if (!kit._id) {
      return;
    }
    fetch(process.env.REACT_APP_PROXY_HOST + '/liste/kits/' + kit._id, { method: 'DELETE' })
      .then(() => history.push('/kits'));
  };

  const showAppareil = (appareil) => {
    history.push({ pathname: '/device/' + appareil._id, appareilid: appareil._id, state: { appareil, editMode } });
  };

  return (
    <div>
      <FormControlLabel control={<Checkbox checked={editMode} onChange={() => setEditMode(!editMode)} name="editMode" color="primary" />} label="Modifer?" />
      <h3>Appareils</h3>
      <List component="nav" aria-label="secondary mailbox folders">
        {(kit.Appareils || []).map((appareil) => (
          <ListItem button key={appareil._id} onClick={() => showAppareil(appareil)}>
            <Device _id={appareil._id} />
            <ListItemText primary={appareil.no} />
            <ListItemText primary={getDeviceRole(appareil.fonction)} />
            <ListItemText primary={appareil._id} />
          </ListItem>
        ))}
      </List>
      {editMode && !isLoading && <div><KitFormAdd createMode={createMode} formData={kit} dbid={kit._id} /></div>}
      <Button variant="contained" onClick={handleDelete}>Effacer</Button>
    </div>
  );
};

export default KitDetails;



// WEBPACK FOOTER //
// src/components/kits/KitDetails.js